import React from "react";
import LoginUser from "../Components/Login";

function Login() {
  return (
    <div className="w-screen flex items-center justify-center h-screen px-6">
      <LoginUser />
    </div>
  );
}

export default Login;
